import { validator } from "@/utils/validator";

export const settingSchema = validator.object().shape({
  irohanaSystemNotificationEmail: validator.string().emptyToNull().email().max(60).label("いろはな宛のシステム通知用メールアドレス").required(),
  clientSystemNotificationEmail: validator.string().emptyToNull().email().max(60).label("お客様宛のシステム通知用メールアドレス").required(),
  otherNotificationEmail: validator.string().emptyToNull().email().max(60).label("その他の通知先メールアドレス").required(),
  chatNotificationEmail: validator.string().emptyToNull().email().max(60).label("チャットの通知先メールアドレス").required(),
});
